import * as constants from "../constants";

export function getOrgData(data) {
    return {
        type: constants.GET_ORG_DATA_WEB,
        payload: data
    };
}

